import type { Match } from '@brochure/shared'

// Il triangolo dei bicchieri (base in alto, punta in basso) è già in stoccopong-stats.ts: niente da
// duplicare, la pagina partita lo usa con questo nome più leggibile in un contesto di sola partita.
export { heatmapLayout as cupLayout } from './stoccopong-stats'

/** Secondi trascorsi formattati "mm:ss". */
export function formatClock(totalSeconds: number): string {
  const clamped = Math.max(0, Math.floor(totalSeconds))
  const minutes = Math.floor(clamped / 60)
  const seconds = clamped % 60
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

/** Secondi trascorsi nella partita: se il timer è fermo è `timerElapsed`; se corre, ci si somma il
 * tempo passato da `timerStartedAt` (il server, non il client, decide quando il timer riparte). */
export function elapsedAt(match: Pick<Match, 'timerElapsed' | 'timerRunning' | 'timerStartedAt'>, now: Date): number {
  if (!match.timerRunning || !match.timerStartedAt) return match.timerElapsed
  const runningSeconds = Math.max(0, (now.getTime() - Date.parse(match.timerStartedAt)) / 1000)
  return Math.floor(match.timerElapsed + runningSeconds)
}
